// Supabase client for Govern360.
//
// Reads configuration from window.ENV which is populated by /env-config.js
// loaded BEFORE the bundle (see each app's index.html). This is the same
// runtime-config pattern CloudTrust360 uses — it lets us deploy the same
// build artifact to dev/staging/prod and swap Supabase projects via Netlify
// environment-variable substitution at deploy time. No rebuild needed.

import { createClient } from '@supabase/supabase-js';

// Read once at module load.
const w = typeof window !== 'undefined' ? window : {};
const E = w.ENV || {};

export const ENV = {
  SUPABASE_URL: E.SUPABASE_URL || '',
  SUPABASE_ANON_KEY: E.SUPABASE_ANON_KEY || '',
  APP_KIND: E.APP_KIND || 'console',          // 'console' | 'admin'
  APP_VERSION: E.APP_VERSION || 'dev',
  // OAuth: redirect target after Google/Azure return. Defaults to current origin
  // so dev (localhost), preview deploys, and prod all work without rebuild.
  AUTH_REDIRECT_URL:
    E.AUTH_REDIRECT_URL ||
    (typeof window !== 'undefined' ? `${window.location.origin}/auth/callback` : ''),
};

if (!ENV.SUPABASE_URL || !ENV.SUPABASE_ANON_KEY) {
  // Fail loud — a misconfigured env-config.js is the #1 cause of "app boots,
  // login button does nothing" in CT360's history. Make it obvious.
  // eslint-disable-next-line no-console
  console.error(
    '[govern360] Supabase config missing. Check /env-config.js is loaded ' +
      'and SUPABASE_URL + SUPABASE_ANON_KEY are set. Current ENV:',
    { ...ENV, SUPABASE_ANON_KEY: ENV.SUPABASE_ANON_KEY ? '[set]' : '[empty]' }
  );
}

export const supabase = createClient(
  ENV.SUPABASE_URL || 'https://placeholder.supabase.co',
  ENV.SUPABASE_ANON_KEY || 'placeholder',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      // Use a distinct storage key per app so localhost dev of both console
      // and admin doesn't share a session and confuse you.
      storageKey: `govern360-${ENV.APP_KIND}-auth`,
    },
  }
);
